function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 56,
  r: 56,
  fill: "#2EAE65",
  fillOpacity: 0.1
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1494 37.1324H31.9048L31.1255 36.2396V34.0984C31.1255 33.5419 30.9044 33.0081 30.5109 32.6146C30.1174 32.2211 29.5836 32 29.0271 32C28.7517 32 28.4789 32.0543 28.2245 32.1598C27.97 32.2653 27.7389 32.4199 27.5442 32.6148C27.3496 32.8096 27.1952 33.041 27.0901 33.2956C26.9849 33.5501 26.9309 33.8229 26.9313 34.0984V36.1337L26.1494 37.1324Z",
  fill: "#E24D4D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.2354 36.8445C28.2417 36.9698 28.2746 37.0923 28.3317 37.204C28.3889 37.3157 28.4691 37.414 28.5671 37.4924C28.665 37.5709 28.7785 37.6276 28.8999 37.659C29.0214 37.6904 29.1482 37.6957 29.2718 37.6745C29.3955 37.6533 29.5133 37.6062 29.6174 37.5361C29.7215 37.4661 29.8096 37.3748 29.8759 37.2683C29.9421 37.1617 29.985 37.0423 30.0018 36.918C30.0186 36.7936 30.0088 36.6672 29.9731 36.5469",
  fill: "#E24D4D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3477 31.125H28.7827V32.3255H29.3477V31.125Z",
  fill: "#E24D4D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4183 33.1937C37.4012 33.1443 37.3877 33.0938 37.3779 33.0424C37.3527 32.934 37.3199 32.7902 37.2771 32.5985C37.2244 32.3573 37.1562 32.1197 37.0728 31.8873C37.0223 31.7511 36.987 31.5973 36.9189 31.4434L36.7045 30.9541C36.3166 30.1276 35.8017 29.3668 35.1787 28.6994C34.3604 27.8368 33.3695 27.1561 32.2707 26.7019C31.6449 26.4385 30.9894 26.2522 30.3186 26.147C29.5951 26.0416 28.861 26.0297 28.1345 26.1117C27.7522 26.1519 27.3731 26.2177 26.9996 26.3085C26.8104 26.3488 26.6263 26.4219 26.4346 26.48C26.2421 26.5334 26.0541 26.6017 25.8722 26.6842C25.0995 26.9967 24.3804 27.4282 23.741 27.9629C22.3221 29.1329 21.3218 30.7324 20.8911 32.5203C20.6643 33.4782 20.6088 34.4687 20.7271 35.446C20.831 36.4569 21.1245 37.4391 21.5922 38.3413L21.7385 38.6162L21.7561 38.6515V38.6894C21.2896 40.2026 20.8356 41.7159 20.3917 43.161L20.2732 43.0526L23.8772 41.1736L23.9201 41.1509L23.9604 41.1812C25.4672 42.3431 27.3244 42.9581 29.2269 42.9251C31.1293 42.8921 32.964 42.2131 34.4296 40.9996C35.1811 40.3713 35.8214 39.621 36.3237 38.7802C36.7253 38.0779 37.0347 37.3269 37.2443 36.5456C37.3857 35.9522 37.4701 35.3467 37.4965 34.7373C37.4965 34.485 37.4965 34.2681 37.4965 34.0739C37.4965 33.8797 37.4662 33.7259 37.4561 33.5922C37.446 33.4586 37.4359 33.3703 37.4309 33.2971C37.4269 33.2636 37.4269 33.2298 37.4309 33.1963C37.4398 33.2284 37.4457 33.2614 37.4486 33.2946C37.4486 33.3686 37.4612 33.467 37.4864 33.5897C37.5015 33.7234 37.5192 33.8823 37.5419 34.0739C37.5646 34.2656 37.5419 34.4901 37.5419 34.7398C37.5278 35.3545 37.4518 35.9663 37.3149 36.5658C37.1135 37.3591 36.8082 38.1223 36.4069 38.8356C35.9045 39.6948 35.2598 40.4624 34.5002 41.1055C33.5702 41.8819 32.4855 42.4512 31.3183 42.7756C30.1511 43.1 28.9282 43.1721 27.731 42.987C26.3218 42.7632 24.99 42.1939 23.8545 41.33H23.9403L20.3413 43.214L20.1597 43.3098L20.2202 43.1055L21.5821 38.6339V38.707L21.4333 38.4271C20.9562 37.505 20.6568 36.5014 20.5506 35.4687C20.4272 34.4686 20.4852 33.4544 20.7221 32.4749C21.1633 30.652 22.1858 29.0222 23.6351 27.8318C24.2893 27.2905 25.0236 26.854 25.8117 26.538C25.9968 26.4541 26.1882 26.385 26.3842 26.3311C26.5784 26.2757 26.765 26.2025 26.9592 26.1622C27.3382 26.0689 27.7234 26.0032 28.1118 25.9654C28.8504 25.8841 29.5965 25.8994 30.3312 26.0108C31.0108 26.1235 31.6745 26.3165 32.3085 26.5859C33.4193 27.0536 34.4182 27.7516 35.2392 28.6338C35.8624 29.3136 36.3732 30.0883 36.7525 30.9289C36.8256 31.1055 36.8962 31.2694 36.9593 31.4333C37.0223 31.5973 37.0601 31.7461 37.1081 31.8848C37.1899 32.1191 37.2531 32.3594 37.2972 32.6036C37.3325 32.7927 37.3628 32.9415 37.383 33.0525C37.3978 33.0988 37.4096 33.1459 37.4183 33.1937Z",
  fill: "#263238"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5155 48.15L90.0039 47.7188L91.6609 88.1629L30.0615 87.5929L30.5155 48.15Z",
  fill: "#2EAE65"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5122 48.1451L58.6688 25.3631C59.2473 24.8956 59.9693 24.6418 60.7131 24.6446C61.4569 24.6473 62.177 24.9064 62.752 25.3782L90.0031 47.7138",
  fill: "#2EAE65"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M30.5122 48.1451L58.6688 25.3631C59.2473 24.8956 59.9693 24.6418 60.7131 24.6446C61.4569 24.6473 62.177 24.9064 62.752 25.3782L90.0031 47.7138",
  fill: "black"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.0609 87.5901C29.9877 87.5195 34.7494 82.319 40.699 75.9759C46.6486 69.6329 51.5289 64.5459 51.6045 64.614C51.6802 64.6821 46.916 69.8826 40.9664 76.2282C35.0168 82.5737 30.1366 87.6582 30.0609 87.5901Z",
  fill: "#263238"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M91.6602 88.1622C91.5846 88.2303 86.9465 83.1357 81.302 76.7851C75.6576 70.4345 71.1431 65.2289 71.2137 65.1608C71.2843 65.0927 75.9275 70.1873 81.5719 76.5405C87.2163 82.8936 91.741 88.0941 91.6602 88.1622Z",
  fill: "#263238"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M90.004 47.7188L60.1299 71.5827L30.5156 48.15",
  fill: "black"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5083 50.3557L33.4175 31.7781L85.5061 31.1602L86.0937 50.7088L60.1264 71.2663L33.5083 50.3557Z",
  fill: "#FAFAFA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M33.508 50.3563C33.508 50.3563 33.677 50.4824 33.9973 50.7321L35.4097 51.8317L40.7943 56.036L60.1665 71.224H60.1009L86.0607 50.6589L86.0355 50.7119C85.9245 46.9843 85.806 43.07 85.6849 39.0901C85.6067 36.4092 85.526 33.761 85.4478 31.1632L85.5134 31.2263L33.4248 31.819L33.4651 31.7786C33.4853 37.6223 33.503 42.2654 33.5131 45.4483C33.5131 47.0398 33.5131 48.2655 33.5131 49.0953V50.036C33.5131 50.2478 33.5131 50.3563 33.5131 50.3563C33.5131 50.3563 33.5131 50.2504 33.5131 50.041C33.5131 49.8317 33.5131 49.5164 33.5131 49.1053C33.5131 48.2756 33.4954 47.0524 33.4828 45.4634C33.4626 42.2755 33.4324 37.6299 33.3945 31.7786V31.7357H33.4349L85.526 31.0977H85.5891V31.1632C85.6672 33.7585 85.7454 36.4066 85.8261 39.0876C85.9472 43.07 86.0632 46.9817 86.1767 50.7119V50.7447L86.1515 50.7649L60.174 71.3123L60.1412 71.3375L60.1084 71.3123L40.7489 56.0739L35.3971 51.8494L33.9847 50.7396C33.6669 50.4874 33.508 50.3563 33.508 50.3563Z",
  fill: "#263238"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2745 40.516C77.2745 40.5513 69.3073 40.6295 59.4837 40.6875C49.6602 40.7455 41.6904 40.7682 41.6904 40.7303C41.6904 40.6925 49.6552 40.6169 59.4837 40.5563C69.3123 40.4958 77.2745 40.4781 77.2745 40.516Z",
  fill: "#263238"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2745 45.7641C77.2745 45.802 69.3073 45.8802 59.4837 45.9382C49.6602 45.9962 41.6904 46.0163 41.6904 45.981C41.6904 45.9457 49.6552 45.8675 59.4837 45.807C69.3123 45.7465 77.2745 45.7288 77.2745 45.7641Z",
  fill: "#263238"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2745 51.8155C77.2745 51.8508 69.3073 51.929 59.4837 51.9895C49.6602 52.05 41.6904 52.0677 41.6904 52.0298C41.6904 51.992 49.6552 51.9163 59.4837 51.8583C69.3123 51.8003 77.2745 51.7776 77.2745 51.8155Z",
  fill: "#263238"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M77.274 57.8626C77.274 57.9005 69.675 57.9736 60.3004 58.0316C50.9258 58.0896 43.3267 58.1047 43.3242 58.0694C43.3217 58.0341 50.9233 57.9585 60.3004 57.9005C69.6775 57.8425 77.274 57.8273 77.274 57.8626Z",
  fill: "#263238"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M70.6111 63.1728C70.5428 63.1843 70.4735 63.1894 70.4042 63.1879L69.804 63.2056L67.6047 63.2409L60.3437 63.3443C57.5088 63.3922 54.9388 63.4073 53.0801 63.4098H50.8808H50.2805C50.2114 63.4111 50.1422 63.4069 50.0737 63.3972C50.142 63.3857 50.2113 63.3806 50.2805 63.3821L50.8808 63.367L53.0801 63.3291L60.3411 63.2257C63.176 63.1778 65.746 63.1627 67.6022 63.1602H69.804H70.4042C70.4734 63.16 70.5425 63.1642 70.6111 63.1728Z",
  fill: "#263238"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9051 68.2765C63.9051 68.3118 62.2078 68.3421 60.122 68.3421C58.0362 68.3421 56.3389 68.3118 56.3389 68.2765C56.3389 68.2412 58.0388 68.2109 60.122 68.2109C62.2052 68.2109 63.9051 68.2387 63.9051 68.2765Z",
  fill: "#263238"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M79.5192 66.0862C83.8491 66.0862 87.3592 62.5762 87.3592 58.2462C87.3592 53.9163 83.8491 50.4062 79.5192 50.4062C75.1893 50.4062 71.6792 53.9163 71.6792 58.2462C71.6792 62.5762 75.1893 66.0862 79.5192 66.0862Z",
  fill: "#002912"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3996 66.0862C82.7295 66.0862 86.2396 62.5762 86.2396 58.2462C86.2396 53.9163 82.7295 50.4062 78.3996 50.4062C74.0697 50.4062 70.5596 53.9163 70.5596 58.2462C70.5596 62.5762 74.0697 66.0862 78.3996 66.0862Z",
  fill: "#E8EEF4"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M79.5197 52.6639V62.7245H77.9541V54.2113H76.1597V52.6445L79.5197 52.6639Z",
  fill: "#E24D4D"
});

function SvgEnvelope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.6efa22c9.svg";
export { ForwardRef as ReactComponent };